<script>
import App from "@/pages/layouts/app.vue";
import Card from "@/pages/components/card.vue";
import Datatable from "@wielink-application/shared/js/mixins/datatable";
import {Link} from "@inertiajs/vue3";
export default {
  mixins: [Datatable],
  components: {Link, App, Card},
}
</script>

<template>
  <App title="Producten">
    <template #topButtons>
      <Link :href="route('products.create')" class="btn btn-primary me-2">
        <i class="bi bi-plus-lg"></i>
        Product toevoegen
      </Link>
    </template>

    <Card>
      <Table ref="table" id="products" :config="tableConfig"/>
    </Card>
  </App>
</template>